module.exports = __webpack_public_path__ + "img/project.fdd7df7f.jpg";